// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__sjFtU","col":"styles_col__1McZ3"};